export { default as PaymentTerms } from './payment-terms'
